import * as React from 'react'
import * as css from './Footer.module.css'
import { graphql, Link, useStaticQuery } from 'gatsby'
import nl2br from 'utils/nl2br'
import logo from 'assets/fastech-logo-white.svg'
import hexDark from 'assets/hex-dark.svg'
import Social from './Social'
import FooterLinks from './FooterLinks'
import Office from './Office'
import PrivacyPolicy from './PrivacyPolicy'

const Footer = ({ simple }) => {
	const { sanitySite } = useStaticQuery(query)

	return (
		<footer className="relative overflow-hidden bg-suede-black pb-8 pt-12 text-white md:pt-16">
			<figure className={css.hex}>
				<img src={hexDark} alt="" width={766} height={401} draggable="false" />
			</figure>

			<div className="ctnr padding-x relative z-[1] flex gap-8 <md:flex-col">
				<div>
					<div>
						<Link to="/">
							<img
								className="w-[150px]"
								src={logo}
								alt="FASTECH"
								width={170}
								height={26}
							/>
						</Link>
					</div>

					<div className="technical mt-8 leading-relaxed <md:hidden">
						<p>{nl2br(sanitySite.slogan)}</p>
					</div>

					<Social links={sanitySite.social} />
				</div>

				<div className="grow md:text-right">
					<FooterLinks hideLinks={simple} />

					<div className="mt-8 flex flex-wrap items-start gap-x-12 gap-y-8 md:justify-end">
						<Office office={sanitySite.contact} />

						{sanitySite.offices?.map((office, key) => (
							<Office office={office} key={key} />
						))}
					</div>

					<div className="mt-8 flex flex-wrap items-center justify-end gap-[1em] text-sm">
						License #794519
						<PrivacyPolicy />
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer

const query = graphql`
	query Footer {
		sanitySite {
			slogan
			contact {
				title
				address
				tel
				email
			}
			offices {
				title
				address
				tel
				email
			}
			social
		}
	}
`
